import { render, staticRenderFns } from "./SpecialPrices.vue?vue&type=template&id=d32f62c4&scoped=true&"
import script from "./SpecialPrices.vue?vue&type=script&lang=js&"
export * from "./SpecialPrices.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPrices.vue?vue&type=style&index=0&id=d32f62c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f62c4",
  null
  
)

export default component.exports